import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60b0ea0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Email", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Group", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("cancel")

import "@/assets/css/action-buttons.css";

import {
  Ref,
  ref,
  withDefaults,
  watch,
  computed,
} from "vue";
import BaseCommandModal from "../ActionModals/_BaseCommandModal.vue";
import { Button as KButton } from "@progress/kendo-vue-buttons";
import { DropDownList as KDropDownList } from "@progress/kendo-vue-dropdowns";
import { Loader } from "@progress/kendo-vue-indicators";

import {
  ClientManager,
  ClientManagerGroup,
  CommissionUserRole,
  SALES_REP_GROUPS,
} from "../typesAndConstants";
import ActionResultMessage from "./Components/ActionResultMessage.vue";

import * as api from "../api";
import { deepClone, makeAuditedCommandParams } from "../helpers";

//#endregion
type ModalProps = {
  show?: boolean;
  clientManager: ClientManager;
};

//#region PROPS

const __default__ = {
  name: "ChangeClientManagerInfo",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean, default: false },
    clientManager: null
  },
  emits: ["command-executed", "close-modal"],
  setup(__props: any, { emit }) {

const props = __props as { show: boolean, clientManager: ClientManager }

//#region IMPORTS

// Global CSS

//#endregion

//#region EMITS

//#endregion

const makeAuditValue = (group: ClientManagerGroup) => ({
  ClientManagerGroup: group,
});

const makeCommandParams = () => {
  const oldValue = makeAuditValue(groupOrig?.key);
  const newValue = makeAuditValue(group.value.key);
  
  return makeAuditedCommandParams(
    CommissionUserRole.ClientManager,
    clientManagerId.value,
    oldValue,
    newValue,
    note.value,
  );
};

const clientManagerTitle =
  props.clientManager?.Group == "Account Handlers"
    ? "Sales Rep"
    : "Account Hanlder";

const saving = ref(false);
const showActionResultMessage = ref(false);
const note = ref("");
const errorMessages: Ref<string[]> = ref([]);
const hasError = computed(() => !!errorMessages.value.length);
const clientManagerId = computed(() => props.clientManager.Id ?? 0);

const salesRepGroup = SALES_REP_GROUPS.filter(
  o => o.value == props.clientManager?.Group,
)[0];

const group: Ref<{ key: ClientManagerGroup; value: string }> =
  ref(salesRepGroup);
let groupOrig = deepClone(salesRepGroup);
watch(
  () => props.model,
  (n, o) => {
    showActionResultMessage.value = false;
    errorMessages.value = [];
  },
);

//#region EVENT HANDLERS
const onCloseModal = (): void => emit("close-modal");

const onCancel = () => emit("close-modal");
const onSave = async () => {
  try {
    errorMessages.value = [];
    showActionResultMessage.value = false;
    saving.value = true;
    api.setClientManagerInfo(makeCommandParams());
    groupOrig = deepClone(group.value);
    emit("command-executed");
  } catch (error: any) {
    errorMessages.value.push(error?.message ? error?.message : error);
  } finally {
    saving.value = false;
    showActionResultMessage.value = true;
  }
};

const onNoteChange = (event: any): void => {
  note.value = event;
};

//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCommandModal, {
    show: props.show,
    title: 'Change Transferred Status',
    onCloseModal: onCloseModal,
    onNoteChanged: onNoteChange
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(clientManagerTitle)), 1),
        _createElementVNode("div", null, _toDisplayString(props.clientManager.FullName.slice(4)), 1),
        _hoisted_3,
        _createElementVNode("div", null, _toDisplayString(props.clientManager.Email), 1),
        _hoisted_4,
        _createElementVNode("div", null, [
          _createVNode(_unref(KDropDownList), {
            modelValue: group.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((group).value = $event)),
            "data-items": _unref(SALES_REP_GROUPS),
            "text-field": 'value',
            "data-item-key": 'key'
          }, null, 8, ["modelValue", "data-items"])
        ])
      ]),
      (showActionResultMessage.value)
        ? (_openBlock(), _createBlock(ActionResultMessage, {
            key: 0,
            "has-error": _unref(hasError),
            "error-messages": errorMessages.value
          }, null, 8, ["has-error", "error-messages"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(KButton), {
        class: "action safe",
        onClick: onSave
      }, {
        default: _withCtx(() => [
          (saving.value)
            ? (_openBlock(), _createBlock(_unref(Loader), {
                key: 0,
                "theme-color": 'light',
                type: 'pulsing'
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "save"))
        ]),
        _: 1
      }),
      _createVNode(_unref(KButton), {
        class: "action no-action",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})